"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const DropdownMultipleValues_1 = require("Views/Shared/Components/DropdownMultipleValues/DropdownMultipleValues");
const DropdownSingleValue_1 = require("Views/Shared/Components/DropdownSingleValue/DropdownSingleValue");
const context_1 = require("../context");
const app_1 = require("app");
const Filter = ({ filter }) => {
    const { isLoading, setIsHitsLoading, setLastUserAction } = (0, context_1.useSearchResultContext)();
    const { items, label, key, gtmKey, isHidden, type, refine, clearRefinements } = filter;
    const selectedOption = React.useMemo(() => items === null || items === void 0 ? void 0 : items.find(item => item.selected), [items]);
    const hierarchyResetValue = React.useMemo(() => {
        return selectedOption && type === app_1.FilterTypeEnum.HierarchySelect ? selectedOption.value : '';
    }, [selectedOption, type]);
    const filterHandler = React.useCallback((value, reset, isUnselect = false) => {
        setIsHitsLoading(true);
        if (reset) {
            setLastUserAction({ name: app_1.LastUserActionNameEnum.Unfilter, key: gtmKey, value, type });
            if (type === app_1.FilterTypeEnum.HierarchySelect) {
                return refine(hierarchyResetValue);
            }
            return clearRefinements();
        }
        const actionName = isUnselect
            ? app_1.LastUserActionNameEnum.Unfilter
            : app_1.LastUserActionNameEnum.Filter;
        refine(value);
        setLastUserAction({
            name: actionName,
            key: gtmKey,
            value,
            type,
        });
    }, [
        clearRefinements,
        gtmKey,
        hierarchyResetValue,
        refine,
        setIsHitsLoading,
        setLastUserAction,
        type,
    ]);
    const options = React.useMemo(() => {
        const resetOption = {
            value: '',
            label,
            count: 0,
            selected: false,
        };
        return (items === null || items === void 0 ? void 0 : items.length) === 0 ? [resetOption] : [resetOption, ...(items || [])];
    }, [items, label]);
    const filterItem = React.useMemo(() => ({
        isDisabled: items.length === 0,
        placeholder: label,
        title: label,
        groupValue: key,
        value: '',
        items: options,
    }), [items, label, key, options]);
    if (isHidden || items === undefined) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [type === app_1.FilterTypeEnum.MultiSelect && ((0, jsx_runtime_1.jsx)(DropdownMultipleValues_1.DropdownMultipleValues, { filter: filterItem, groupValue: key, isFiltersLoading: isLoading, onFilterChange: filterHandler })), (type === app_1.FilterTypeEnum.SingleSelect || type === app_1.FilterTypeEnum.HierarchySelect) && ((0, jsx_runtime_1.jsx)(DropdownSingleValue_1.DropdownSingleValue, { filter: filterItem, groupValue: key, isFiltersLoading: isLoading, onFilterChange: filterHandler }))] }));
};
exports.Filter = Filter;
